/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function TrendUpwardIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "trend-upward", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M3.5 17.5L10.5 10.5L14.5 14.5L21.5 7.5M21.5 7.5V13M21.5 7.5H16", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(TrendUpwardIcon);
export default ForwardRef;
//# sourceMappingURL=trendUpwardIcon.js.map